import storage from './storage';

const KEY = 'crm_feature_flags';

export const FEATURE_DEFS = [
  { id: 'contacts.import',    label: 'Listen importieren',    desc: 'CSV/XLSX Leads importieren' },
  { id: 'contacts.export',    label: 'Leads exportieren',     desc: 'Daten als CSV herunterladen' },
  { id: 'contacts.delete',    label: 'Leads löschen',         desc: 'Leads in den Papierkorb' },
  { id: 'analytics.view',     label: 'Analytics & Reports',   desc: 'Analytics-Bereich sehen' },
  { id: 'pipeline.view',      label: 'Pipeline sehen',        desc: 'Deal-Pipeline anzeigen' },
  { id: 'pipeline.edit',      label: 'Pipeline bearbeiten',   desc: 'Deals verschieben/anlegen' },
  { id: 'automations.manage', label: 'Automationen',          desc: 'Regeln anlegen und starten' },
  { id: 'trash.view',         label: 'Papierkorb',            desc: 'Gelöschte Leads ansehen' },
  { id: 'trash.restore',      label: 'Leads wiederherstellen',desc: 'Aus Papierkorb zurück' },
];

const DEFAULTS = {
  admin: [
    'contacts.view','contacts.edit','contacts.delete','contacts.import','contacts.export',
    'analytics.view','users.manage','settings.manage','automations.manage',
    'pipeline.view','pipeline.edit','trash.view','trash.restore',
  ],
  manager: [
    'contacts.view','contacts.edit','contacts.delete','contacts.import','contacts.export',
    'analytics.view','automations.manage','pipeline.view','pipeline.edit',
    'trash.view','trash.restore',
  ],
  nutzer: [
    'contacts.view','contacts.edit','contacts.import',
    'pipeline.view','pipeline.edit',
  ],
  viewer: ['contacts.view','pipeline.view'],
  demo: [
    'contacts.view','contacts.edit','contacts.delete',
    'pipeline.view','pipeline.edit','analytics.view',
    'automations.manage','trash.view','trash.restore',
  ],
};

export const EDITABLE_ROLES = ['manager', 'nutzer', 'viewer'];

export function loadFeatureFlags() {
  const saved = storage.get(KEY, null);
  if (!saved) return { ...DEFAULTS };
  return { ...DEFAULTS, ...saved, admin: DEFAULTS.admin };
}

export function saveFeatureFlags(flags) {
  storage.set(KEY, { ...flags, admin: DEFAULTS.admin });
}

// Module-level cache so hasPermission doesn't re-parse every call
let _cache = null;
export function getFlags() {
  if (!_cache) _cache = loadFeatureFlags();
  return _cache;
}
export function reloadFlags() { _cache = null; }
